import { render, staticRenderFns } from "./routerPush.vue?vue&type=template&id=284b691d&scoped=true&"
import script from "./routerPush.vue?vue&type=script&lang=js&"
export * from "./routerPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b691d",
  null
  
)

export default component.exports